export enum BucketType {
  Natural = 'NATURAL',
  WithProof = 'WITH_PROOF',
  WithoutProof = 'WITHOUT_PROOF',
  MissingProof = 'MISSING_PROOF',
}
